<template>
  <div class="transfer-container">
    <!-- 左侧：树形结构 -->
    <div class="transfer-left">
      <div class="search-box">
        <el-input

            placeholder="请输入关键字"
            prefix-icon="el-icon-search"
            clearable
            v-model="searchKeyword"
            @input="handleSearch"
            @clear="handleSearchClear"
        />
      </div>

      <div class="tree-wrapper">
        <el-tree
            ref="tree"
            :key="treeKey"
            :data="filteredTreeData"
            show-checkbox
            node-key="id"
            :default-checked-keys="leftCheckedKeys"
            :check-strictly="false"
            :props="{ label: 'label', children: 'children' }"
            @check-change="handleLeftCheckChange"
            :expand-on-click-node="false"
            class="custom-tree"
        />
      </div>
    </div>

    <!-- 中间：穿梭按钮 -->
    <div class="transfer-buttons" style="height: 500px;align-items: center">
      <img src="@/assets/img/dc0.png" v-if="tempSelectedKeys.length === 0"  style="width: 30px">
      <img src="@/assets/img/dc1.png" v-if="tempSelectedKeys.length !==0"  @click="addSelected"  style="width: 30px;cursor: pointer">
      <img src="@/assets/img/dr0.png" v-if="toBeRemoved.length === 0" style="width: 30px;margin-top: 20px">
      <img src="@/assets/img/dr1.png" v-if="toBeRemoved.length !== 0" @click="removeSelected" style="width: 30px;margin-top: 20px;cursor: pointer">
<!--      <el-button size="small" type="primary" @click="addSelected" icon="el-icon-arrow-right" :disabled="tempSelectedKeys.length === 0"></el-button>-->
<!--      <el-button size="small" @click="removeSelected" icon="el-icon-arrow-left" :disabled="toBeRemoved.length === 0"></el-button>-->
    </div>

    <!-- 右侧：已选人员（可勾选，但不立即删除） -->
    <div class="transfer-right">
      <div class="title">已选人员：</div>
      <div class="selected-list">
        <div >
        <el-checkbox-group v-model="toBeRemoved" style="display: block">
          <el-checkbox
              v-for="item in selectedPeople"
              :key="item.id"
              :label="item.id"
          >
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTransfer',
  props: {
    treeData: {
      type: Array,
      default: () => []
    },
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      treeKey: 0,
      searchKey: '',
      searchKeyword: '',
      value: [], // 最终已选人员 ID 列表（v-model）
      tempSelectedKeys: [], // 左侧临时选中的 key（待添加）
      toBeRemoved: [], // 右侧勾选的 key（待移除）
      filteredTreeData: [],
      originalTreeData: [],// 保存原始数据，用于重建 parent
      validNodeIds: new Set() // ✅ 存储所有应保留的节点 ID
    };
  },

  computed: {
    // 扁平化树形结构，用于快速查找 id → label
    allPeopleFlat() {
      const flatten = (nodes, result = []) => {
        nodes.forEach(node => {
          if (node.type === 'person') {
            result.push({ id: node.id, label: node.label });
          }
          if (node.children) {
            flatten(node.children, result);
          }
        });
        return result;
      };
      return flatten(this.treeData); // 原始 treeData，不是 filteredTreeData
    },

    // 右侧已选人员（用于回显！）
    selectedPeople() {
      const valueSet = new Set(this.value.map(String)); // 统一转字符串
      return this.allPeopleFlat.filter(item => valueSet.has(item.id));
    },
    // 所有叶子节点（人员）
    // allPeople() {
    //   const people = [];
    //   const traverse = (node) => {
    //     if (node.children && node.children.length > 0) {
    //       node.children.forEach(traverse);
    //     } else {
    //       people.push({ ...node });
    //     }
    //   };
    //   this.originalTreeData.forEach(traverse);
    //   return people;
    // },

    // 当前已选人员（用于右侧显示）
    // selectedPeople: {
    //
    //   // return this.allPeople.filter(item => this.value.includes(item.id));
    //   get() {
    //     return this.allPeople.filter(item => this.value.includes(item.id));
    //   },
    //   set(newValue) {
    //     // 通常你不是要改 allPeople，而是要更新 value（即选中的 id 列表）
    //     const ids = newValue.map(item => item.id);
    //     this.$emit('input', ids); // 如果 value 是 v-model 绑定的 prop
    //     // 或者如果是 data：
    //     // this.value = ids;
    //   }
    // },

    // 左侧树应勾选的 keys（已添加 + 临时选中 - 待移除）
    // leftCheckedKeys() {
    //   const added = this.value.filter(id => !this.toBeRemoved.includes(id));
    //   return [...new Set([...added, ...this.tempSelectedKeys])];
    // },
    leftCheckedKeys() {
      // 已选中且未被标记移除的 + 临时选中的（未被移除）
      const kept = this.value.filter(id => !this.toBeRemoved.includes(id));
      const temp = this.tempSelectedKeys.filter(id => !this.toBeRemoved.includes(id));
      return [...new Set([...kept, ...temp])];
    }
  },
  watch: {
    treeData: {
      handler(newVal) {
        this.originalTreeData = JSON.parse(JSON.stringify(newVal)); // 深拷贝
        this.filteredTreeData = newVal;
      },
      immediate: true
    },
    searchKey(val) {
      // this.filterTree(val);
      this.$refs.tree.filter(val); // ✅ 手动触发过滤
    },
    selectedIds: {
      handler(newVal) {
        this.value = newVal;
        // this.leftCheckedKeys = newVal
        // this.selectedPeople = this.findPersons(selectedIds)

      },
      immediate: true,
      deep: true
    },

  },
  created() {
    const data = this.treeData;
    setTimeout(()=>{
      const arr = this.selectedIds;
      const targetIds = new Set(arr.map(String));
      // this.value = this.selectedIds;
      // this.value = targetIds
// 直接提取所有 person 节点并过滤
      const matched = data
          .flatMap(company => company.children || [])
          .flatMap(position => position.children || [])
          .filter(person => targetIds.has(person.id));
      this.value = matched.map(person => person.id);
      // this.selectedPeople = this.selectedPeople.concat(matched);
    },500)

  },
  methods: {
    findPersons(nodes, result = []) {
      for (const node of nodes) {
        if (node.children) {
          findPersons(node.children, result); // 递归子节点
        }
        // 如果当前节点是 person 类型且 id 在目标列表中
        if (node.type === "person" && targetIds.has(node.id)) {
          result.push(node);
        }
      }
      return result;
    },
    handleTreeCheck(checkedKeys, {checkedNodes }) {
      this.tempSelectedKeys = checkedNodes
          .filter(node => !node.children?.length)
          .map(node => node.id);
    },
    // 左侧树勾选变化（只更新 tempSelectedKeys）
    handleLeftCheckChange(checked, node) {
      const isChecked = node; // 更可靠的方式是用 node.checked
      const nodeId = checked.id;
      const getAllLeafIds = (nodes) => {
        let ids = [];
        const traverse = (list) => {
          list.forEach(item => {
            if (!item.children || item.children.length === 0) {
              ids.push(item.id);
            } else {
              traverse(item.children);
            }
          });
        };
        traverse(nodes);
        return ids;
      };
      if (isChecked) {
        // 勾选：添加当前节点及其所有叶子子节点
        const leafIds = checked.children ? getAllLeafIds(checked.children) : [nodeId];
        leafIds.forEach(id => {
          if (!this.tempSelectedKeys.includes(id)) {
            this.tempSelectedKeys.push(id);
          }
        });
      } else {
        // 取消：移除当前节点及其所有叶子子节点
        const leafIds = checked.children ? getAllLeafIds(checked.children) : [nodeId];
        this.tempSelectedKeys = this.tempSelectedKeys.filter(id => !leafIds.includes(id));
      }
    },

    // 添加按钮：将 tempSelectedKeys 加入 value，并清空 temp
    addSelected() {
      const newAdded = this.tempSelectedKeys.filter(id => !this.value.includes(id));
      this.value = [...this.value, ...newAdded];
      this.$emit('selected', this.value);
      this.tempSelectedKeys = []; // 清空临时选中
    },

    // 移除按钮：从 value 中移除 toBeRemoved，并清空 toBeRemoved
    removeSelected() {
      if (this.toBeRemoved.length === 0) return;
      if(this.toBeRemoved.length >0){
        this.toBeRemoved = this.toBeRemoved.map(Number);
        this.value = this.value.map(Number);
      }
      // 更新已选列表
      // this.value = this.value.filter(id => !this.toBeRemoved.includes(id));
      this.value = this.value
          .filter(id => !this.toBeRemoved.includes(id))
          .map(String);
      this.$emit('selected', this.value);
      this.toBeRemoved = [];
      this.$nextTick(() => {
        if (!this.$refs.tree) return;
        // 获取当前应勾选的 keys（确保类型一致！）
        const newChecked = this.leftCheckedKeys;
        // 先清空，再设置
        this.$refs.tree.setCheckedKeys([]);
        setTimeout(() => {
          this.$refs.tree.setCheckedKeys(newChecked);

        }, 0);

      });
    },

    handleSearchClear() {
      this.searchKey = '';
      this.filteredTreeData = this.originalTreeData;
    },
    //ceshi

    // 🌲 递归过滤树：只要节点匹配，就保留整棵子树
    filterTree(nodes, keyword) {
      if (!keyword) return nodes; // 无关键词：返回全部

      const result = [];
      for (const node of nodes) {
        // 创建新节点（避免修改原始数据）
        const newNode = { ...node };

        // ✅ 情况1：当前节点匹配 → 保留整棵子树（不递归过滤 children）
        if (newNode.label?.includes(keyword)) {
          result.push(newNode); // 直接 push，children 全保留
        }
        // ✅ 情况2：当前节点不匹配 → 递归过滤子节点
        else if (newNode.children && newNode.children.length) {
          const filteredChildren = this.filterTree(newNode.children, keyword);
          if (filteredChildren.length > 0) {
            // 有匹配的后代 → 保留当前节点 + 过滤后的子节点
            newNode.children = filteredChildren;
            result.push(newNode);
          }
          // 否则：完全丢弃该分支
        }
        // 情况3：叶子节点且不匹配 → 丢弃
      }
      return result;
    },

    // 🔍 处理搜索
    handleSearch(value) {
      this.searchKeyword = value?.trim() || '';
      this.updateFilteredTree();
    },

    // 🧹 清空搜索
    // handleSearchClear() {
    //   this.handleSearch('');
    // },

    // 🔄 更新 filteredTreeData
    updateFilteredTree() {
      this.filteredTreeData = this.filterTree(this.originalTreeData, this.searchKeyword);
      // 可选：强制 tree 重新渲染（如果遇到展开状态异常）
      this.treeKey = Date.now();
    }
  },
  mounted() {
    this.originalTreeData = JSON.parse(JSON.stringify(this.treeData));
    this.filteredTreeData = this.treeData;
  }
};
</script>

<style scoped lang="scss">
.transfer-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.transfer-left,
.transfer-right {
  flex: 1;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  height: 500px;
}

.transfer-left .search-box {
  padding: 8px 12px;
  background: #f5f7fa;
  border-bottom: 1px solid #dcdfe6;
}

.transfer-left .tree-wrapper {
  height: 400px;
  overflow-y: auto;
  padding: 8px;
}

.custom-tree ::v-deep .el-tree-node__content {
  height: 32px;
  line-height: 32px;
}

.transfer-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 60px;
  margin: 0 10px;
  padding: 10px 0;

}

.transfer-right .title {
  padding: 8px 12px;
  background: #f5f7fa;
  border-bottom: 1px solid #dcdfe6;
  font-size: 14px;
  color: #606266;
}

.transfer-right .selected-list {
  padding: 8px;
  height: 90%;
  overflow-y: auto;
  margin-bottom: 16px;

}
::v-deep .selected-list .el-checkbox{
  display: block;
  margin: 0 0 10px 0;
}
</style>